import React, { createContext, useContext, ReactNode } from 'react';
import DealdenLoader from './DealdenLoader';
import useDealdenLoader from '../hooks/useDealdenLoader';

interface DealdenLoaderContextType {
  showLoader: (options?: {
    message?: string;
    size?: 'small' | 'medium' | 'large';
    fullScreen?: boolean;
  }) => void;
  hideLoader: () => void;
  updateLoader: (options: {
    message?: string;
    size?: 'small' | 'medium' | 'large';
    fullScreen?: boolean;
  }) => void;
  isVisible: boolean;
}

const DealdenLoaderContext = createContext<DealdenLoaderContextType | undefined>(undefined);

interface DealdenLoaderProviderProps {
  children: ReactNode;
}

export const DealdenLoaderProvider: React.FC<DealdenLoaderProviderProps> = ({ children }) => {
  const { loaderState, showLoader, hideLoader, updateLoader, isVisible } = useDealdenLoader();

  return (
    <DealdenLoaderContext.Provider value={{ showLoader, hideLoader, updateLoader, isVisible }}>
      {children}
      {loaderState.isVisible && (
        <DealdenLoader
          message={loaderState.message}
          size={loaderState.size}
          fullScreen={loaderState.fullScreen}
        />
      )}
    </DealdenLoaderContext.Provider>
  );
};

export const useGlobalLoader = (): DealdenLoaderContextType => {
  const context = useContext(DealdenLoaderContext);
  if (context === undefined) {
    throw new Error('useGlobalLoader must be used within a DealdenLoaderProvider');
  }
  return context;
};

export default DealdenLoaderProvider; 